import React, { useState, useEffect } from 'react'
import { Steps,} from 'antd'
import { useFKspjdListQuery } from '../../store/DianShangYeWuApi';
function CostNodeAdd(props) {
    const [items, setItems] = useState([]); 
    const {data, isSuccess} = useFKspjdListQuery({ddzc_spjd_qy_id:props.qy_id,ddzc_spjd_user_id:props.user_id},{skip:!props.user_id});
    useEffect(() => {
        if(isSuccess && data){
            if(data.Status === 'success' && data.Result){
                const sortedData = [...data.Result].sort((a, b) => {
                        return Number(a.ddzc_sp_xuhao) - Number(b.ddzc_sp_xuhao);
                })
                const arr = sortedData.map((item) => ({
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>{item.ddzc_sp_name}</span>       ,
                    content:<span style={{fontSize:"12px"}}>{item.ddzc_sp_yh_name}</span>,
                }))
                setItems([{
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                    content:<span style={{fontSize:"12px"}}>{props.yh_name}</span>,
                },
                {
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                    content:<span style={{fontSize:"12px"}}>{props.yh_name}</span>,
                },...arr]);
            }
        }
    },[data, isSuccess, props.qy_id, props.user_id, props.yh_name])    
    return (
        <Steps items={items} current={0} size="small" titlePlacement="vertical"/>
    )
}

export default CostNodeAdd